import React, { useEffect, useRef, useState } from "react"

import TextField from "@material-ui/core/TextField"
import InputAdornment from "@material-ui/core/InputAdornment"
import FormControl from "@material-ui/core/FormControl"
import IconButton from "@material-ui/core/IconButton"

import VisibilityOffIcon from "@material-ui/icons/VisibilityOff"
import VisibilityIcon from "@material-ui/icons/Visibility"

import { usePasswordChecklist } from "common/hooks"

const PasswordTextFieldLogin = props => {
    const { isMasked: isMaskedProp = true, CheckListProps = {}, ...rest } = props

    const input = useRef(null)
    const [isMasked, setIsMasked] = useState(isMaskedProp)
    const [value, setValue] = useState(rest.value)
    const [hasError, renderCheckList] = usePasswordChecklist(value)

    const fontSize = window.innerWidth * 0.015

    useEffect(() => {
        if (CheckListProps.onChange) {
            CheckListProps.onChange(hasError)
        }

        if (input.current) {
            const isNotValid = value.length && hasError
            input.current.setCustomValidity(isNotValid ? "Ungültiges Muster" : "")
        }
    }, [value, hasError, CheckListProps])

    function onToggleField() {
        setIsMasked(!isMasked)
    }

    function onChange(event) {
        setValue(event.target.value)

        if (rest.onChange) {
            rest.onChange(event)
        }
    }

    return (
        <>
            <TextField
                {...rest}
                fullWidth
                value={value}
                onChange={onChange}
                type={isMasked ? "password" : "text"}
                inputProps={{
                    ref: input
                }}
                InputLabelProps={{ style: { color: "white", fontSize } }}
                InputProps={{
                    style: {
                        color: "white",
                        fontWeight: "bold",
                        fontSize,
                        borderBottom: "1px solid white"
                    },
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                tabIndex="-1"
                                edge="end"
                                color="inherit"
                                onClick={onToggleField}
                            >
                                {isMasked ? <VisibilityOffIcon /> : <VisibilityIcon />}
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />

            {CheckListProps.show && (
                <FormControl fullWidth margin="normal">
                    {renderCheckList()}
                </FormControl>
            )}
        </>
    )
}

export default PasswordTextFieldLogin
